import React from "react"
import { OrderPaymentSveaCheckout } from "lib/types/generated/graphql-types"
import {
  getPaymentMethodDisplayName
} from "helpers/getPaymentDisplayName"
import { Label } from "components/Ui/List/List"
import { Container, Row, StatusWrapper, SveaLogoWrapper } from "./Styled"
import ListEntry from "../../../../../components/Order/Ui/ListEntry"
import StatusSmall from "../../../../../components/Ui/Status/StatusSmall"
import { getProviderLogo } from "helpers/providers"

type Props = {
  orderPayment: OrderPaymentSveaCheckout
}

const Svea = ({ orderPayment }: Props) => {
  if (!orderPayment) return null

  return (
    <>
      <Container>
        <Row $columns={"1fr 1fr 1fr"}>
          <ListEntry
            label={"Payment provider"}
            value={<SveaLogoWrapper>{getProviderLogo(orderPayment.providerName)}</SveaLogoWrapper>}
          />{" "}
          <ListEntry
            label={"Payment method"}
            value={getPaymentMethodDisplayName(orderPayment.method)}
          />
          <ListEntry label={"Payment reference"} value={orderPayment.reference} />
          <ListEntry label={"Merchant ID"} value={orderPayment.sveaMerchantId} />
          <ListEntry label={"Svea order ID"} value={orderPayment.sveaOrderId} />
        </Row>
      </Container>
      <Container>
        <Row>
          <div>
            <Label>Payment status</Label>
            <StatusWrapper>
              <StatusSmall status={orderPayment.status.toUpperCase()} />
            </StatusWrapper>
          </div>
        </Row>
      </Container>
    </>
  )
}

export default Svea
